import apiFetch from '../../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `TipoIntervencion/cambioEstadoSeleccionTipoIntervencion `, method: 'POST', body: {list}, token: token})
}
